export enum DisplayType {
  LIST = 'list',
  GRID = 'grid',
  GRID_EXTENDED = 'grid-extended',
}
